"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _drawerMainMenuItem = _interopRequireDefault(require("./components/drawer-main-menu-item"));

var _drawerMainMenuDivider = _interopRequireDefault(require("./components/drawer-main-menu-divider"));

require("./style/drawer-main-menu.scss");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Drawer Main menu - contains the menu items, it will hide the drawer on mobile after a item is selected
 *
 * @class DrawerMainMenu
 * @extends {Component}
 * @param menuItems - main menuItems that should be displayed
 * @param toggleDrawer - toggle drawer func
 */
var DrawerMainMenu = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(DrawerMainMenu, _Component);

  var _super = _createSuper(DrawerMainMenu);

  function DrawerMainMenu() {
    (0, _classCallCheck2["default"])(this, DrawerMainMenu);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(DrawerMainMenu, [{
    key: "render",
    value: function render() {
      var _this = this;

      var classOfMainMenu = this.props.hidden ? 'main-menu hidden' : 'main-menu';
      return /*#__PURE__*/_react["default"].createElement("nav", {
        className: classOfMainMenu
      }, this.props.menuItems.map(function (menuItem, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index
        }, menuItem.subItems && menuItem.subItems.map(function (item, index) {
          if (item.divider) {
            if (!item.visible) {
              return null;
            }

            return /*#__PURE__*/_react["default"].createElement(_drawerMainMenuDivider["default"], (0, _extends2["default"])({
              key: index
            }, item));
          }

          return /*#__PURE__*/_react["default"].createElement(_drawerMainMenuItem["default"], (0, _extends2["default"])({
            key: item.tag + item.link,
            toggleDrawer: _this.props.toggleDrawer,
            isFreeAccount: _this.props.isFreeAccount,
            isMobile: _this.props.isMobile,
            toggleDrawerOnClick: _this.props.toggleDrawerOnClick
          }, item));
        }));
      }));
    }
  }]);
  return DrawerMainMenu;
}(_react.Component);

DrawerMainMenu.propTypes = {
  isMobile: _propTypes["default"].bool.isRequired,
  toggleDrawerOnClick: _propTypes["default"].bool,
  hidden: _propTypes["default"].bool,
  menuItems: _propTypes["default"].array,
  toggleDrawer: _propTypes["default"].func,
  isFreeAccount: _propTypes["default"].bool
};
DrawerMainMenu.defaultProps = {
  menuItems: [],
  isFreeAccount: true
};
var _default = DrawerMainMenu;
exports["default"] = _default;